window.addEventListener('load', () => {
    const locationsComponents = document.querySelectorAll<HTMLElement>('.locations-component');

    locationsComponents.forEach(component => {
        const locations = component.querySelectorAll<HTMLElement>('.location-post');

        locations.forEach(location => {
            location.addEventListener('click', () => {
                locations.forEach(loc => loc.classList.remove('active'));
                location.classList.add('active');
            });
        });
    });
})